import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Menu } from '@CommonComponents/buttons'

export const ActionButton = ({ items, children }) => {
  const [activeAction, setActiveAction] = useState(null)

  return (
    <div className="text-center">
      <Menu
        label="Actions"
        align="end"
        className="me-btn me-btn-secondary me-btn-sm me-btn-menu-trigger"
        onSelect={setActiveAction}
      >
        {items.map(item =>
          item.separator ? (
            <div key={item.id} className="me-menu-sep" role="separator" />
          ) : item.heading ? (
            <div key={item.id} className="me-menu-heading" role="presentation">
              {item.label}
            </div>
          ) : (
            <Button
              key={item.id}
              data-value={item.id}
              className={`me-menu-item${item.danger ? ' is-danger' : ''}`}
              icon={item.icon}
              href={item.href}
              disabled={item.disabled}
              onClick={item.onSelect}
            >
              {item.label}
            </Button>
          )
        )}
      </Menu>
      {/* Dialogs stay outside the closing, inert menu surface. Menu restores
          trigger focus before onSelect, so dialogs return there on close. */}
      {children?.({ activeAction, close: () => setActiveAction(null) })}
    </div>
  )
}

ActionButton.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string,
      icon: PropTypes.string,
      href: PropTypes.string,
      danger: PropTypes.bool,
      disabled: PropTypes.bool,
      onSelect: PropTypes.func,
      heading: PropTypes.bool,
      separator: PropTypes.bool,
    })
  ).isRequired,
  children: PropTypes.func,
}
